import React, { useId } from 'react'
import { SuperGrain } from '../SuperGrain'

export const WhitePinkBlueSpheres = ({
  hideGrain,
  svgProps,
}: {
  hideGrain?: boolean
  svgProps: React.SVGProps<SVGSVGElement>
}) => {
  const uniqueId = useId()
  const maskId = `grainFilter-whitepinkblue-${uniqueId}`

  return (
    <svg
      {...svgProps}
      viewBox="0 0 2215 1667"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_whitepinkblue)">
        <g filter="url(#filter0_f_whitepinkblue)">
          <ellipse
            cx="1246.71"
            cy="762.151"
            rx="563.533"
            ry="553.972"
            transform="rotate(-30.7308 1246.71 762.151)"
            fill="white"
          />
        </g>
        <g filter="url(#filter1_f_whitepinkblue)">
          <ellipse
            cx="1246.71"
            cy="762.15"
            rx="522.557"
            ry="513.691"
            transform="rotate(-30.7308 1246.71 762.15)"
            fill="#176AE5"
          />
        </g>
        <g filter="url(#filter2_f_whitepinkblue)">
          <circle
            cx="904.664"
            cy="843.433"
            r="400"
            transform="rotate(-33.0533 904.664 843.433)"
            fill="#EF91F7"
          />
        </g>
        <g filter="url(#filter3_f_whitepinkblue)">
          <circle
            cx="974.664"
            cy="843.433"
            r="400"
            transform="rotate(-33.0533 974.664 843.433)"
            fill="#EBB9CB"
          />
        </g>
        <g filter="url(#filter4_f_whitepinkblue)">
          <ellipse
            cx="567.951"
            cy="1611.21"
            rx="1326.69"
            ry="627.413"
            transform="rotate(-22.4331 567.951 1611.21)"
            fill="#232323"
          />
        </g>
        <g filter="url(#filter5_f_whitepinkblue)">
          <ellipse
            cx="741.5"
            cy="-272.691"
            rx="1326.69"
            ry="627.413"
            transform="rotate(18.1953 741.5 -272.691)"
            fill="#232323"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_whitepinkblue"
          x="638.902"
          y="158.914"
          width="1215.63"
          height="1206.47"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="23.335"
            result="effect1_foregroundBlur_whitepinkblue"
          />
        </filter>
        <filter
          id="filter1_f_whitepinkblue"
          x="569.703"
          y="89.3827"
          width="1354.02"
          height="1345.53"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="78.335"
            result="effect1_foregroundBlur_whitepinkblue"
          />
        </filter>
        <filter
          id="filter2_f_whitepinkblue"
          x="54.1436"
          y="192.912"
          width="1501.04"
          height="1501.04"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="175.237"
            result="effect1_foregroundBlur_whitepinkblue"
          />
        </filter>
        <filter
          id="filter3_f_whitepinkblue"
          x="124.144"
          y="192.912"
          width="1501.04"
          height="1501.04"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="175.237"
            result="effect1_foregroundBlur_whitepinkblue"
          />
        </filter>
        <filter
          id="filter4_f_whitepinkblue"
          x="-921.734"
          y="601.368"
          width="2979.37"
          height="2019.68"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="120"
            result="effect1_foregroundBlur_whitepinkblue"
          />
        </filter>
        <filter
          id="filter5_f_whitepinkblue"
          x="-734.173"
          y="-1198.62"
          width="2951.35"
          height="1851.86"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="100"
            result="effect1_foregroundBlur_whitepinkblue"
          />
        </filter>
        <clipPath id="clip0_whitepinkblue">
          <rect width="2215" height="1667" />
        </clipPath>
        <mask id={maskId}>
          <rect width="100%" height="100%" fill="black" />
          <g filter="url(#filter0_f_whitepinkblue)">
            <ellipse
              cx="1246.71"
              cy="762.151"
              rx="563.533"
              ry="553.972"
              transform="rotate(-30.7308 1246.71 762.151)"
              fill="white"
            />
          </g>
          <g filter="url(#filter1_f_whitepinkblue)">
            <ellipse
              cx="1246.71"
              cy="762.15"
              rx="522.557"
              ry="513.691"
              transform="rotate(-30.7308 1246.71 762.15)"
              fill="white"
            />
          </g>
          <g filter="url(#filter2_f_whitepinkblue)">
            <circle
              cx="904.664"
              cy="843.433"
              r="400"
              transform="rotate(-33.0533 904.664 843.433)"
              fill="white"
            />
          </g>
          <g filter="url(#filter3_f_whitepinkblue)">
            <circle
              cx="974.664"
              cy="843.433"
              r="400"
              transform="rotate(-33.0533 974.664 843.433)"
              fill="white"
            />
          </g>
        </mask>
      </defs>
      {!hideGrain && (
        <foreignObject
          x="0"
          y="0"
          width="100%"
          height="100%"
          mask={`url(#${maskId})`}
        >
          <SuperGrain zIndex={0} />
        </foreignObject>
      )}
    </svg>
  )
}
